import React from 'react';
import {StencilProvider} from "@amzn/stencil-react-components/context";
import defaultTheme from "@amzn/stencil-react-theme-default";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {LandingPage} from "src/components/pages/landingPage/LandingPage";
import {ClientListPage} from "src/components/pages/clientListPage/ClientListPage";
import AuthenticatedRoute from "src/auth/AuthenticatedRoute";
import {ClientCreationPage} from "src/components/pages/clientCreationPage/ClientCreationPage";
import {
    SHOW_CLIENTS_ROUTE,
    SHOW_EXPERIMENTS_ROUTE,
    SHOW_EXPERIMENT_DETAILS,
    EDIT_EXPERIMENT_DETAILS,
    CREATE_NEW_CLIENT,
    CREATE_EXPERIMENT_ROUTE
} from "src/constants/RoutingConstants";
import {ExperimentListPage} from "src/components/pages/experimentListPage/ExperimentListPage";
import {ExperimentCreationPage} from "src/components/pages/experimentCreationPage/ExperimentCreationPage";
import {ExperimentDetailsPage} from "src/components/pages/experimentDetailsPage/ExperimentDetailsPage";
import {
    ExperimentDetailsUpdationPage
} from "src/components/pages/experimentDetailsUpdationPage/ExperimentDetailsUpdationPage";

export class App extends React.Component {
    render() {
        return (
            <StencilProvider theme={defaultTheme}>
                <Router basename={"/pxtexperimentauthoringservice"}>
                    <AuthenticatedRoute>
                        <Switch>
                            <Route exact path="/">
                                {<LandingPage/>}
                            </Route>
                            <Route exact path= {SHOW_CLIENTS_ROUTE}>
                                {<ClientListPage/>}
                            </Route>
                            <Route exact path={CREATE_NEW_CLIENT}
                                   component={(props) => <ClientCreationPage {...props}/>}/>
                            <Route exact path={SHOW_EXPERIMENTS_ROUTE}
                                   component={(props) => <ExperimentListPage {...props}/>}/>
                            <Route exact path={CREATE_EXPERIMENT_ROUTE}
                                   component={(props) => <ExperimentCreationPage {...props}/>}/>
                            <Route exact path={SHOW_EXPERIMENT_DETAILS}
                                   component={(props) => <ExperimentDetailsPage {...props}/>}/>
                            <Route exact path={EDIT_EXPERIMENT_DETAILS}
                                   component={(props) => <ExperimentDetailsUpdationPage {...props}/>}/>
                        </Switch>
                    </AuthenticatedRoute>
                </Router>
            </StencilProvider>
        );
    }
}

export default App;
